import Toast from "../components/Sweetalert/Sweetalert";

/**
 * Check if user has a specific permission
 * @param {Object} user - User object from API
 * @param {string} requiredPermission - Permission name to check (e.g., 'view_user')
 * @returns {boolean} True if user has the permission, false otherwise
 */
export const hasPermission = (user, requiredPermission) => {
  // Check if user or roles exist
  if (!user?.roles) return false;

  // Check all roles for the required permission
  return user.roles.some((role) =>
    role.permissions?.some(
      (permission) => permission.name === requiredPermission
    )
  );
};

export const hasRole = (userRole, requiredRole) => {
  return userRole.some((role) => requiredRole === role?.name);
};

export const showToast = (title, text, type = "success") => {
  Toast.fire({
    color: "#134F98",
    background: "white",
    icon: type,
    title,
    text,
    position: "top-right",
  });
};

export const trimString = (str, trimNumber = 9) => {
  if (str === null || str === undefined) {
    return "";
  }

  const stringValue = String(str);

  if (stringValue.length > trimNumber) {
    return stringValue.slice(0, trimNumber) + "...";
  }

  return stringValue;
};

export const handleFormValidationErrors = (
  error,
  setFormErrors,
  setGeneralError = null
) => {
  const response = error?.response || error;
  const body = response?.data || error?.data || error;
  const statusCode = response?.status || body?.status || error?.status;

  let extractedFieldErrors = null;

  if (statusCode === 400 || statusCode === 422) {
    // According to your response structure: field errors are in body.data or body.errors
    let errorSource = null;

    if (body?.data && typeof body.data === 'object' && !Array.isArray(body.data)) {
      errorSource = body.data;
    } else if (body?.errors && typeof body.errors === 'object' && !Array.isArray(body.errors)) {
      errorSource = body.errors;
    } else if (body && typeof body === 'object' && !Array.isArray(body)) {
      errorSource = body;
    }

    if (errorSource) {
      const fieldErrors = {};
      Object.entries(errorSource).forEach(([field, messages]) => {
        // Skip metadata fields like status, message, etc.
        if (['status', 'message', 'errorCode', 'success'].includes(field)) return;

        if (Array.isArray(messages)) {
          fieldErrors[field] = messages.join(" ");
        } else if (typeof messages === "string") {
          fieldErrors[field] = messages;
        } else if (typeof messages === "object" && messages !== null) {
          fieldErrors[field] = Object.values(messages).join(" ");
        }
      });

      if (Object.keys(fieldErrors).length > 0) {
        extractedFieldErrors = fieldErrors;
        setFormErrors((prev) => ({ ...prev, ...fieldErrors }));
      }
    }
  }

  if (setGeneralError) {
    let generalMessage = "An unexpected error occurred.";
    if (body?.message) {
      generalMessage = Array.isArray(body.message) ? body.message.join(" ") : body.message;
    } else if (error?.message) {
      generalMessage = error.message;
    }
    setGeneralError(generalMessage);
  }

  return extractedFieldErrors;
};


